import { LanguageOptions, WithdrawalWording } from '@/types';

export const WITHDRAWAL_WORDING: Record<LanguageOptions, WithdrawalWording> = {
  BA: {
    badgeLabel: 'Obrazac',
    pageTitle: 'Zahtjev za odustanak',
    description:
      'Unesite svoje podatke i ostavite komentar kako bi nas tim mogao obraditi vas zahtjev.',
    serviceLabel: 'Usluga',
    serviceUrlLabel: 'URL usluge',
    phoneInputLabel: 'Broj telefona',
    phoneInputPlaceholder: 'Unesite svoj broj telefona',
    emailInputLabel: 'Email',
    emailInputPlaceholder: 'unesite@email.com',
    commentInputLabel: 'Komentar',
    commentInputPlaceholder: 'Ovdje navedite svoj zahtjev',
    submitButtonLabel: 'Posalji moj zahtjev',
    successMessage:
      'Otvorit ce se unaprijed popunjen email. Preostaje vam samo da ga posaljete.',
    errorMessage:
      'Nije moguce otvoriti vasu email aplikaciju. Provjerite je li na vasem uredjaju konfigurirana aplikacija za postu i pokusajte ponovo.',
    autogeneratedEmailNotice:
      'OVAJ EMAIL JE AUTOMATSKI GENERISAN, MOLIMO PRITISNITE DUGME ZA SLANJE',
  },
  BG: {
    badgeLabel: 'Формуляр',
    pageTitle: 'Заявка за отказ',
    description:
      'Попълнете данните си и оставете коментар, за да може нашият екип да обработи вашата заявка.',
    serviceLabel: 'Услуга',
    serviceUrlLabel: 'URL на услугата',
    phoneInputLabel: 'Телефонен номер',
    phoneInputPlaceholder: 'Въведете телефонния си номер',
    emailInputLabel: 'Имейл',
    emailInputPlaceholder: 'vas@primer.com',
    commentInputLabel: 'Коментар',
    commentInputPlaceholder: 'Опишете заявката си тук',
    submitButtonLabel: 'Изпрати моята заявка',
    successMessage:
      'Ще се отвори предварително попълнен имейл. Остава само да го изпратите.',
    errorMessage:
      'Не успяхме да отворим вашето приложение за електронна поща. Проверете дали на устройството ви е конфигурирана пощенска програма и опитайте отново.',
    autogeneratedEmailNotice:
      'ТОЗИ ИМЕЙЛ Е ГЕНЕРИРАН АВТОМАТИЧНО, МОЛЯ НАТИСНЕТЕ БУТОНА ЗА ИЗПРАЩАНЕ',
  },
  CY: {
    badgeLabel: 'Form',
    pageTitle: 'Withdrawal request',
    description:
      'Fill in your details and leave us a comment so our team can process your request.',
    serviceLabel: 'Service',
    serviceUrlLabel: 'Service URL',
    phoneInputLabel: 'Phone number',
    phoneInputPlaceholder: 'Enter your phone number',
    emailInputLabel: 'Email',
    emailInputPlaceholder: 'you@example.com',
    commentInputLabel: 'Comment',
    commentInputPlaceholder: 'Tell us more about your request',
    submitButtonLabel: 'Send my request',
    successMessage: 'A pre-filled email will open. You only need to send it.',
    errorMessage:
      'Unable to open your mail application. Please make sure an email app is configured on your device and try again.',
    autogeneratedEmailNotice:
      'THIS EMAIL HAS BEEN AUTOMATICALLY GENERATED, PLEASE PRESS THE SEND BUTTON',
  },
  CZ: {
    badgeLabel: 'Formular',
    pageTitle: 'Zadost o odstoupeni',
    description:
      'Vyplnte sve udaje a zanechte komentar, aby nas tym mohl vasi zadost zpracovat.',
    serviceLabel: 'Sluzba',
    serviceUrlLabel: 'URL sluzby',
    phoneInputLabel: 'Telefonni cislo',
    phoneInputPlaceholder: 'Zadejte sve telefonni cislo',
    emailInputLabel: 'E-mail',
    emailInputPlaceholder: 'vy@priklad.cz',
    commentInputLabel: 'Komentar',
    commentInputPlaceholder: 'Upresnete zde svou zadost',
    submitButtonLabel: 'Odeslat mou zadost',
    successMessage: 'Otevre se predvyplneny e-mail. Staci jej uz jen odeslat.',
    errorMessage:
      'Nepodarilo se otevrit vasi e-mailovou aplikaci. Zkontrolujte, ze je na vasem zarizeni nastavena posta, a zkuste to znovu.',
    autogeneratedEmailNotice:
      'TENTO E-MAIL BYL VYGENEROVAN AUTOMATICKY, PROSIM STISKNETE TLACITKO ODESLAT',
  },
  DE: {
    badgeLabel: 'Formular',
    pageTitle: 'Widerrufsanfrage',
    description:
      'Geben Sie Ihre Kontaktdaten ein und hinterlassen Sie einen Kommentar, damit unser Team Ihre Anfrage bearbeiten kann.',
    serviceLabel: 'Dienst',
    serviceUrlLabel: 'Dienst-URL',
    phoneInputLabel: 'Telefonnummer',
    phoneInputPlaceholder: 'Geben Sie Ihre Telefonnummer ein',
    emailInputLabel: 'E-Mail',
    emailInputPlaceholder: 'sie@beispiel.de',
    commentInputLabel: 'Kommentar',
    commentInputPlaceholder: 'Beschreiben Sie hier Ihre Anfrage',
    submitButtonLabel: 'Meine Anfrage senden',
    successMessage:
      'Eine vorausgefullte E-Mail wird geoffnet. Sie mussen sie nur noch absenden.',
    errorMessage:
      'Ihre E-Mail-Anwendung konnte nicht geoffnet werden. Bitte prufen Sie, ob auf Ihrem Gerat eine Mail-App eingerichtet ist, und versuchen Sie es erneut.',
    autogeneratedEmailNotice:
      'DIESE E-MAIL WURDE AUTOMATISCH ERSTELLT, BITTE DRUCKEN SIE AUF DIE SENDEN-SCHALTFLACHE',
  },
  DK: {
    badgeLabel: 'Formular',
    pageTitle: 'Fortrydelsesanmodning',
    description:
      'Udfyld dine oplysninger og efterlad en kommentar, sa vores team kan behandle din anmodning.',
    serviceLabel: 'Tjeneste',
    serviceUrlLabel: 'Tjeneste-URL',
    phoneInputLabel: 'Telefonnummer',
    phoneInputPlaceholder: 'Indtast dit telefonnummer',
    emailInputLabel: 'E-mail',
    emailInputPlaceholder: 'dig@eksempel.dk',
    commentInputLabel: 'Kommentar',
    commentInputPlaceholder: 'Beskriv din anmodning her',
    submitButtonLabel: 'Send min anmodning',
    successMessage:
      'En forudfyldt e-mail vil blive abnet. Du skal blot sende den.',
    errorMessage:
      'Det var ikke muligt at abne din mailapp. Kontroller, at en mailapp er konfigureret pa din enhed, og prov igen.',
    autogeneratedEmailNotice:
      'DENNE E-MAIL ER GENERERET AUTOMATISK, TRYK VENLIGST PA SEND-KNAPPEN',
  },
  EE: {
    badgeLabel: 'Vorm',
    pageTitle: 'Taganemistaotlus',
    description:
      'Sisestage oma andmed ja jatke kommentaar, et meie meeskond saaks teie taotluse toodelda.',
    serviceLabel: 'Teenus',
    serviceUrlLabel: 'Teenuse URL',
    phoneInputLabel: 'Telefoninumber',
    phoneInputPlaceholder: 'Sisestage oma telefoninumber',
    emailInputLabel: 'E-post',
    emailInputPlaceholder: 'sina@naide.ee',
    commentInputLabel: 'Kommentaar',
    commentInputPlaceholder: 'Kirjeldage oma soovi siin',
    submitButtonLabel: 'Saada minu taotlus',
    successMessage: 'Avaneb eeltaidetud e-kiri. Teil tuleb see vaid ara saata.',
    errorMessage:
      'Teie meilirakendust ei olnud voimalik avada. Kontrollige, et teie seadmes oleks meilirakendus seadistatud, ja proovige uuesti.',
    autogeneratedEmailNotice:
      'SEE E-KIRI ON AUTOMAATSELT GENEREERITUD, PALUN VAJUTAGE SAATMISE NUPPU',
  },
  EN: {
    badgeLabel: 'Form',
    pageTitle: 'Withdrawal request',
    description:
      'Fill in your details and leave us a comment so our team can process your request.',
    serviceLabel: 'Service',
    serviceUrlLabel: 'Service URL',
    phoneInputLabel: 'Phone number',
    phoneInputPlaceholder: 'Enter your phone number',
    emailInputLabel: 'Email',
    emailInputPlaceholder: 'you@example.com',
    commentInputLabel: 'Comment',
    commentInputPlaceholder: 'Tell us more about your request',
    submitButtonLabel: 'Send my request',
    successMessage: 'A pre-filled email will open. You only need to send it.',
    errorMessage:
      'Unable to open your mail application. Please make sure an email app is configured on your device and try again.',
    autogeneratedEmailNotice:
      'THIS EMAIL HAS BEEN AUTOMATICALLY GENERATED, PLEASE PRESS THE SEND BUTTON',
  },
  FI: {
    badgeLabel: 'Lomake',
    pageTitle: 'Peruuttamispyynto',
    description:
      'Tayta tietosi ja jata kommentti, jotta tiimimme voi kasitella pyyntosi.',
    serviceLabel: 'Palvelu',
    serviceUrlLabel: 'Palvelun URL',
    phoneInputLabel: 'Puhelinnumero',
    phoneInputPlaceholder: 'Anna puhelinnumerosi',
    emailInputLabel: 'Sahkoposti',
    emailInputPlaceholder: 'sina@esimerkki.fi',
    commentInputLabel: 'Kommentti',
    commentInputPlaceholder: 'Kerro pyyntosi tarkemmin tassa',
    submitButtonLabel: 'Laheta pyyntoni',
    successMessage:
      'Esitaytetty sahkoposti avautuu. Sinun tarvitsee vain lahettaa se.',
    errorMessage:
      'Sahkopostisovellusta ei voitu avata. Tarkista, etta laitteellesi on maaritetty sahkopostisovellus, ja yrita uudelleen.',
    autogeneratedEmailNotice:
      'TAMA SAHKOPOSTI ON LUOTU AUTOMAATTISESTI, PAINA OLE HYVA JA LAHETA-PAINIKETTA',
  },
  FR: {
    badgeLabel: 'Formulaire',
    pageTitle: 'Demande de retractation',
    description:
      'Renseignez vos coordonnees et laissez-nous un commentaire afin que notre equipe puisse traiter votre demande.',
    serviceLabel: 'Service',
    serviceUrlLabel: 'URL du service',
    phoneInputLabel: 'Numero de telephone',
    phoneInputPlaceholder: 'Entrez votre numero de telephone',
    emailInputLabel: 'Email',
    emailInputPlaceholder: 'vous@exemple.com',
    commentInputLabel: 'Commentaire',
    commentInputPlaceholder: 'Precisez votre demande ici',
    submitButtonLabel: 'Envoyer ma demande',
    successMessage:
      "Un email pre-rempli va s'ouvrir. Il ne vous reste plus qu'a l'envoyer.",
    errorMessage:
      "Impossible d'ouvrir votre application mail. Verifiez qu'une messagerie est configuree sur votre appareil et reessayez ensuite.",
    autogeneratedEmailNotice:
      "CET EMAIL A ETE GENERE AUTOMATIQUEMENT, MERCI D'APPUYER SUR LE BOUTON D'ENVOI",
  },
  HR: {
    badgeLabel: 'Obrazac',
    pageTitle: 'Zahtjev za odustanak',
    description:
      'Unesite svoje podatke i ostavite komentar kako bi nas tim mogao obraditi vas zahtjev.',
    serviceLabel: 'Usluga',
    serviceUrlLabel: 'URL usluge',
    phoneInputLabel: 'Broj telefona',
    phoneInputPlaceholder: 'Unesite svoj broj telefona',
    emailInputLabel: 'E-mail',
    emailInputPlaceholder: 'vi@primjer.hr',
    commentInputLabel: 'Komentar',
    commentInputPlaceholder: 'Ovdje opisite svoj zahtjev',
    submitButtonLabel: 'Posalji moj zahtjev',
    successMessage:
      'Otvorit ce se unaprijed ispunjen email. Preostaje vam samo da ga posaljete.',
    errorMessage:
      'Nije moguce otvoriti vasu email aplikaciju. Provjerite je li na vasem uredjaju konfigurirana aplikacija za postu i pokusajte ponovo.',
    autogeneratedEmailNotice:
      'OVAJ EMAIL JE AUTOMATSKI GENERIRAN, MOLIMO PRITISNITE GUMB ZA SLANJE',
  },
  LT: {
    badgeLabel: 'Forma',
    pageTitle: 'Atsisakymo prasymas',
    description:
      'Uzpildykite savo duomenis ir palikite komentara, kad musu komanda galetu apdoroti jusu uzklausa.',
    serviceLabel: 'Paslauga',
    serviceUrlLabel: 'Paslaugos URL',
    phoneInputLabel: 'Telefono numeris',
    phoneInputPlaceholder: 'Iveskite savo telefono numeri',
    emailInputLabel: 'El. pastas',
    emailInputPlaceholder: 'jus@example.lt',
    commentInputLabel: 'Komentaras',
    commentInputPlaceholder: 'Patikslinkite savo prasyma cia',
    submitButtonLabel: 'Siusti mano prasyma',
    successMessage:
      'Atsidarys is anksto uzpildytas el. laiskas. Jums beliks ji issiusti.',
    errorMessage:
      'Nepavyko atidaryti jusu el. pasto programos. Patikrinkite, ar jusu irenginyje sukonfiguruota pasto programa, ir bandykite dar karta.',
    autogeneratedEmailNotice:
      'SIS EL. LAISKAS BUVO SUGENERUOTAS AUTOMATISKAI, PRASOME PASPAUSTI SIUNTIMO MYGTUKA',
  },
  LV: {
    badgeLabel: 'Veidlapa',
    pageTitle: 'Atteikuma pieprasijums',
    description:
      'Ievadiet savu informaciju un atstajiet komentaru, lai musu komanda varetu apstradat jusu pieprasijumu.',
    serviceLabel: 'Pakalpojums',
    serviceUrlLabel: 'Pakalpojuma URL',
    phoneInputLabel: 'Talruna numurs',
    phoneInputPlaceholder: 'Ievadiet savu talruna numuru',
    emailInputLabel: 'E-pasts',
    emailInputPlaceholder: 'jus@piemers.lv',
    commentInputLabel: 'Komentars',
    commentInputPlaceholder: 'Aprakstiet savu pieprasijumu seit',
    submitButtonLabel: 'Sutit manu pieprasijumu',
    successMessage:
      'Tiks atverts ieprieks aizpildits e-pasts. Jums tas tikai janosuta.',
    errorMessage:
      'Neizdevas atvert jusu e-pasta lietotni. Parbaudiet, vai jusu ierice ir konfigurta e-pasta programma, un meginiet velreiz.',
    autogeneratedEmailNotice:
      'SIS E-PASTS IR AUTOMATISKI GJENERETS, LUDZU NOSPIEDIET SUTISANAS POGU',
  },
  NO: {
    badgeLabel: 'Skjema',
    pageTitle: 'Angrerettsforesporsel',
    description:
      'Fyll inn opplysningene dine og legg igjen en kommentar slik at teamet vart kan behandle foresporselen din.',
    serviceLabel: 'Tjeneste',
    serviceUrlLabel: 'Tjeneste-URL',
    phoneInputLabel: 'Telefonnummer',
    phoneInputPlaceholder: 'Skriv inn telefonnummeret ditt',
    emailInputLabel: 'E-post',
    emailInputPlaceholder: 'deg@eksempel.no',
    commentInputLabel: 'Kommentar',
    commentInputPlaceholder: 'Beskriv foresporselen din her',
    submitButtonLabel: 'Send foresporselen min',
    successMessage:
      'En forhandsutfylt e-post apnes. Du trenger bare a sende den.',
    errorMessage:
      'Det var ikke mulig a apne e-postappen din. Kontroller at en e-postapp er konfigurert pa enheten din, og prov igjen.',
    autogeneratedEmailNotice:
      'DENNE E-POSTEN ER GENERERT AUTOMATISK, VENNLIGST TRYKK PA SEND-KNAPPEN',
  },
  PL: {
    badgeLabel: 'Formularz',
    pageTitle: 'Wniosek o odstapienie',
    description:
      'Wprowadz swoje dane i zostaw komentarz, aby nasz zespol mogl rozpatrzyc Twoja prosbe.',
    serviceLabel: 'Usluga',
    serviceUrlLabel: 'URL uslugi',
    phoneInputLabel: 'Numer telefonu',
    phoneInputPlaceholder: 'Wpisz swoj numer telefonu',
    emailInputLabel: 'Email',
    emailInputPlaceholder: 'ty@przyklad.pl',
    commentInputLabel: 'Komentarz',
    commentInputPlaceholder: 'Opisz tutaj swoja prosbe',
    submitButtonLabel: 'Wyslij moja prosbe',
    successMessage:
      'Otworzy sie wstepnie wypelniony e-mail. Wystarczy go wyslac.',
    errorMessage:
      'Nie udalo sie otworzyc aplikacji pocztowej. Sprawdz, czy na Twoim urzadzeniu jest skonfigurowana poczta, i sproboj ponownie.',
    autogeneratedEmailNotice:
      'TEN E-MAIL ZOSTAL WYGENEROWANY AUTOMATYCZNIE, PROSIMY NACISNAC PRZYCISK WYSLIJ',
  },
  RO: {
    badgeLabel: 'Formular',
    pageTitle: 'Cerere de retragere',
    description:
      'Completeaza datele tale si lasa-ne un comentariu pentru ca echipa noastra sa iti poata procesa cererea.',
    serviceLabel: 'Serviciu',
    serviceUrlLabel: 'URL serviciu',
    phoneInputLabel: 'Numar de telefon',
    phoneInputPlaceholder: 'Introdu numarul tau de telefon',
    emailInputLabel: 'Email',
    emailInputPlaceholder: 'tu@exemplu.ro',
    commentInputLabel: 'Comentariu',
    commentInputPlaceholder: 'Detaliaza aici cererea ta',
    submitButtonLabel: 'Trimite cererea mea',
    successMessage:
      'Se va deschide un email precompletat. Tot ce trebuie sa faci este sa il trimiti.',
    errorMessage:
      'Nu s-a putut deschide aplicatia ta de email. Verifica daca pe dispozitivul tau este configurata o aplicatie de email si incearca din nou.',
    autogeneratedEmailNotice:
      'ACEST EMAIL A FOST GENERAT AUTOMAT, VA RUGAM SA APASATI BUTONUL DE TRIMITERE',
  },
  RS: {
    badgeLabel: 'Obrazac',
    pageTitle: 'Zahtev za odustanak',
    description:
      'Unesite svoje podatke i ostavite komentar kako bi nas tim mogao da obradi vas zahtev.',
    serviceLabel: 'Usluga',
    serviceUrlLabel: 'URL usluge',
    phoneInputLabel: 'Broj telefona',
    phoneInputPlaceholder: 'Unesite svoj broj telefona',
    emailInputLabel: 'Email',
    emailInputPlaceholder: 'vi@primer.rs',
    commentInputLabel: 'Komentar',
    commentInputPlaceholder: 'Ovde opisite svoj zahtev',
    submitButtonLabel: 'Posalji moj zahtev',
    successMessage:
      'Otvorice se unapred popunjen email. Potrebno je samo da ga posaljete.',
    errorMessage:
      'Nije moguce otvoriti vasu email aplikaciju. Proverite da li je na vasem uredjaju konfigurisana aplikacija za postu i pokusajte ponovo.',
    autogeneratedEmailNotice:
      'OVAJ EMAIL JE AUTOMATSKI GENERISAN, MOLIMO PRITISNITE DUGME ZA SLANJE',
  },
  SE: {
    badgeLabel: 'Formular',
    pageTitle: 'Begäran om utövande av ångerrätt',
    description:
      'Fyll i dina uppgifter och lamna en kommentar sa att vart team kan behandla din begaran.',
    serviceLabel: 'Tjanst',
    serviceUrlLabel: 'Tjanst-URL',
    phoneInputLabel: 'Telefonnummer',
    phoneInputPlaceholder: 'Ange ditt telefonnummer',
    emailInputLabel: 'E-post',
    emailInputPlaceholder: 'du@exempel.se',
    commentInputLabel: 'Kommentar',
    commentInputPlaceholder: 'Beskriv din begaran har',
    submitButtonLabel: 'Skicka min begaran',
    successMessage:
      'Ett forifyllt e-postmeddelande kommer att oppnas. Du behover bara skicka det.',
    errorMessage:
      'Det gick inte att oppna din e-postapp. Kontrollera att en e-postapp ar konfigurerad pa din enhet och forsok igen.',
    autogeneratedEmailNotice:
      'DETTA E-POSTMEDDELANDE HAR GENERERATS AUTOMATISKT, VANLIGEN TRYCK PA SKICKA-KNAPPEN',
  },
  SI: {
    badgeLabel: 'Obrazec',
    pageTitle: 'Zahteva za odstop od pogodbe',
    description:
      'Vnesite svoje podatke in pustite komentar, da bo nasa ekipa lahko obdelala vaso zahtevo.',
    serviceLabel: 'Storitev',
    serviceUrlLabel: 'URL storitve',
    phoneInputLabel: 'Telefonska stevilka',
    phoneInputPlaceholder: 'Vnesite svojo telefonsko stevilko',
    emailInputLabel: 'E-posta',
    emailInputPlaceholder: 'vi@primer.si',
    commentInputLabel: 'Komentar',
    commentInputPlaceholder: 'Tukaj opisite svojo zahtevo',
    submitButtonLabel: 'Poslji mojo zahtevo',
    successMessage:
      'Odprlo se bo vnaprej izpolnjeno e-postno sporocilo. Samo se poslati ga morate.',
    errorMessage:
      'Vase e-postne aplikacije ni bilo mogoce odpreti. Preverite, ali je na vasi napravi nastavljena e-posta, in poskusite znova.',
    autogeneratedEmailNotice:
      'TO E-POSTNO SPOROCILO JE BILO USTVARJENO SAMODEJNO, PROSIM PRITISNITE GUMB ZA POSILJANJE',
  },
  SK: {
    badgeLabel: 'Formular',
    pageTitle: 'Ziadost o odstupenie',
    description:
      'Vyplnte svoje udaje a zanechajte komentar, aby nas tim mohol vasu ziadost spracovat.',
    serviceLabel: 'Sluzba',
    serviceUrlLabel: 'URL sluzby',
    phoneInputLabel: 'Telefonne cislo',
    phoneInputPlaceholder: 'Zadajte svoje telefonne cislo',
    emailInputLabel: 'E-mail',
    emailInputPlaceholder: 'vy@priklad.sk',
    commentInputLabel: 'Komentar',
    commentInputPlaceholder: 'Spresnite svoju ziadost tu',
    submitButtonLabel: 'Odoslat moju ziadost',
    successMessage: 'Otvori sa predvyplneny e-mail. Staci ho uz len odoslat.',
    errorMessage:
      'Nepodarilo sa otvorit vasu e-mailovu aplikaciu. Skontrolujte, ci je na vasom zariadeni nastavena posta, a skuste to znova.',
    autogeneratedEmailNotice:
      'TENTO E-MAIL BOL VYGENEROVANY AUTOMATICKY, PROSIM STLACTE TLACIDLO ODOSLAT',
  },
};
